import { skillAcquisitionProgramActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  masterData: null,
  skillAcquisitionProgramList: null,
  skillAcquisitionProgramDetail: null,
  saved_skillAcquisitionProgram: null,
  saved_skillAcquisitionProgramFromLibrary: null,
  save_copyPatientSkillAcquisitionProgram: null,
  deleted_skillAcquisitionProgram: null,
  programActiveStatus: false,
  programInstruction: false,
  masterCurriculumLibraries: null,
  masterDomainByLibrary: null,
  masterProgramByDomain: null,
  skillAcquisitionProgramSingleGraphData: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case skillAcquisitionProgramActionTypes.get_masterData.REQUEST:
    case skillAcquisitionProgramActionTypes.program_active_status.REQUEST:
    case skillAcquisitionProgramActionTypes.patch_program_instruction.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case skillAcquisitionProgramActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case skillAcquisitionProgramActionTypes.save_skillAcquisitionProgram.REQUEST:
      return {
        ...state,
        loading: true,
        saved_skillAcquisitionProgram: null,
      };
    case skillAcquisitionProgramActionTypes.save_skillAcquisitionProgram.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_skillAcquisitionProgram: payload,
      };

    case skillAcquisitionProgramActionTypes.save_skillAcquisitionProgramFromLibrary.REQUEST:
      return {
        ...state,
        loading: true,
        saved_skillAcquisitionProgramFromLibrary: null,
      };
    case skillAcquisitionProgramActionTypes.save_skillAcquisitionProgramFromLibrary.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_skillAcquisitionProgramFromLibrary: payload,
      };

    case skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionProgramList: null,
      };
    case skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionProgramList: payload,
      };
    case skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramDetail.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionProgramDetail: null,
      };
    case skillAcquisitionProgramActionTypes.get_skillAcquisitionProgramDetail.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionProgramDetail: payload,
      };
    case skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_skillAcquisitionProgram: null,
      };
    case skillAcquisitionProgramActionTypes.delete_skillAcquisitionProgram.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_skillAcquisitionProgram: payload,
      };
    case skillAcquisitionProgramActionTypes.program_active_status.SUCCESS:
      return {
        ...state,
        programActiveStatus: payload,
        loading: false,
      };
    case skillAcquisitionProgramActionTypes.patch_program_instruction.SUCCESS:
      return {
        ...state,
        programInstruction: payload,
        loading: false,
      };

    case skillAcquisitionProgramActionTypes.get_masterCurriculumLibraries.REQUEST:
      return {
        ...state,
        loading: true,
        masterCurriculumLibraries: null,
      };
    case skillAcquisitionProgramActionTypes.get_masterCurriculumLibraries.SUCCESS:
      return {
        ...state,
        loading: false,
        masterCurriculumLibraries: payload,
      };

    case skillAcquisitionProgramActionTypes.get_masterDomainsByLibrary.REQUEST:
      return {
        ...state,
        loading: true,
        masterDomainByLibrary: null,
      };
    case skillAcquisitionProgramActionTypes.get_masterDomainsByLibrary.SUCCESS:
      return {
        ...state,
        loading: false,
        masterDomainByLibrary: payload,
      };

    case skillAcquisitionProgramActionTypes.get_masterprogramByDomain.REQUEST:
      return {
        ...state,
        loading: true,
        masterProgramByDomain: null,
      };
    case skillAcquisitionProgramActionTypes.get_masterprogramByDomain.SUCCESS:
      return {
        ...state,
        loading: false,
        masterProgramByDomain: payload,
      };
    case skillAcquisitionProgramActionTypes.save_copyPatientSkillAcquisitionProgram.REQUEST:
        return {
          ...state,
          loading: true,
          save_copyPatientSkillAcquisitionProgram: null,
        };
    case skillAcquisitionProgramActionTypes.save_copyPatientSkillAcquisitionProgram.SUCCESS:
        return {
          ...state,
          loading: false,
          save_copyPatientSkillAcquisitionProgram: payload,
        };
    case skillAcquisitionProgramActionTypes.get_getPatientSkillAcquisitionProgramSingleGraph.REQUEST:
        return {
          ...state,
          loading: true,
          skillAcquisitionProgramSingleGraphData: null,
        };
    case skillAcquisitionProgramActionTypes.get_getPatientSkillAcquisitionProgramSingleGraph.SUCCESS:
        return {
          ...state,
          loading: false,
          skillAcquisitionProgramSingleGraphData: payload,
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/reducers/skillAquisitionProgramReducer.js